import { StyleSheet, Platform } from 'react-native';
import {
  GROUP_HERO_BANNER_ACTION_ICON_COLOR,
  GROUP_HERO_BANNER_ACTION_SURFACE,
  GROUP_HERO_BANNER_ACTION_SURFACE_BORDER,
} from '../GroupHeroBanner/GroupHeroBanner.constants';

export const getSquadTvModeToggleStyles = () =>
  StyleSheet.create({
    buttonIcon: {
      width: 32,
      height: 32,
      borderRadius: 16,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: GROUP_HERO_BANNER_ACTION_SURFACE,
      borderWidth: 1,
      borderColor: GROUP_HERO_BANNER_ACTION_SURFACE_BORDER,
      flexShrink: 0,
      ...(Platform.OS === 'web' && {
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)' as never,
      }),
    },
    buttonWithLabel: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      paddingHorizontal: 10,
      paddingVertical: 6,
      borderRadius: 16,
      backgroundColor: GROUP_HERO_BANNER_ACTION_SURFACE,
      borderWidth: 1,
      borderColor: GROUP_HERO_BANNER_ACTION_SURFACE_BORDER,
      flexShrink: 0,
      ...(Platform.OS === 'web' && {
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)' as never,
      }),
    },
    buttonPressed: {
      opacity: 0.72,
    },
    buttonHover: {
      opacity: 0.9,
    },
    label: {
      fontSize: 12,
      fontWeight: '700',
      color: GROUP_HERO_BANNER_ACTION_ICON_COLOR,
    },
  });
